import { BenefitDTO, CustomBenefitDetailsDTO } from 'probonio-shared-ui/api';
import { CUSTOM_BENEFIT_ICONS } from 'probonio-shared-ui/component/icon';
import {
  BenefitListItemExtensionInterface,
  BenefitListItemProps,
} from '../../../extension/interface/benefit-list-item.extension.interface';

export class CustomBenefitListItemExtension extends BenefitListItemExtensionInterface {
  isHidden(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[], context?: Record<string, unknown>): boolean {
    const detailCustom = activeBenefit.details as CustomBenefitDetailsDTO;
    return !detailCustom.showTile;
  }

  getListItemProps(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[]): BenefitListItemProps {
    const detailCustom = activeBenefit.details as CustomBenefitDetailsDTO;
    const monthlyBudget = detailCustom.monthlyGrant;

    return {
      icon: CUSTOM_BENEFIT_ICONS[detailCustom.iconName],
      title: detailCustom.title,
      titleKey: '',
      navigateTo: `/custom/${detailCustom.customBenefitId}`,
      picture: detailCustom.imageURL,
      benefitProgress: 100,
      descriptionKey: monthlyBudget ? `benefitModule:benefit.${activeBenefit.benefit}.description` : undefined,
      descriptionValues: { maxRefund: monthlyBudget },
    };
  }

  getKey(activeBenefit: BenefitDTO): string {
    const detailCustom = activeBenefit.details as CustomBenefitDetailsDTO;
    return `${activeBenefit.benefit}${detailCustom.customBenefitId}`;
  }
}
